/**
 * @generated SignedSource<<c18ced5edfeb84f1cf42c40e1c2ac881>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_PRICE" | "FIXED_HOURS" | "TIME_AND_MATERIALS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HighLevelBudgetNumbers_project$data = {
  readonly id: string;
  readonly useBaseline: boolean | null;
  readonly hasInvoices: boolean | null;
  readonly budget: number | null;
  readonly budgetType: BUDGET_TYPE | null;
  readonly defaultPeriodBudgetType: PERIOD_BUDGET_TYPE | null;
  readonly timeRegBasedPlusDoneScopeCompletion: number | null;
  readonly rateCard: {
    readonly currency: string | null;
  } | null;
  readonly financialNumbers: {
    readonly baselineRevenue: number | null;
    readonly actualRevenue: number | null;
    readonly baselineProfit: number | null;
    readonly actualProfit: number | null;
    readonly totalRevenueProfitAtCompletion: number | null;
    readonly baselineMargin: number | null;
    readonly actualMargin: number | null;
    readonly totalRevenueMarginAtCompletion: number | null;
    readonly billableActualTimeAndExpenses: number | null;
    readonly actualCost: number | null;
    readonly billableForecastTimeAndExpensesToComplete: number | null;
    readonly forecastCostToComplete: number | null;
    readonly totalCostAtCompletion: number | null;
    readonly billableTotalTimeAndExpensesAtCompletion: number | null;
    readonly invoiced: number | null;
    readonly paid: number | null;
    readonly recognitionProfit: number | null;
    readonly recognitionProfitPercentage: number | null;
    readonly totalRevenueRecognition: number | null;
    readonly projectTotalForecastTimeAndExpensesToCompleteInPast: number | null;
    readonly baselineCost: number | null;
    readonly baselineVsForecastCost: number | null;
    readonly allActualTimeAndExpenses: number | null;
    readonly allForecastTimeAndExpensesToComplete: number | null;
    readonly allTotalTimeAndExpensesAtCompletion: number | null;
    readonly baselineTimeAndExpenses: number | null;
    readonly baselineVsBillableTotalTimeAndExpensesAtCompletion: number | null;
    readonly estimatedCost: number | null;
    readonly planVsTotalCostAtCompletion: number | null;
    readonly billablePlannedTimeAndExpenses: number | null;
  } | null;
  readonly financialNumbersToCurrentMonth: {
    readonly recognitionLockedProfit: number | null;
    readonly recognitionLockedProfitPercentage: number | null;
    readonly recognitionLockedRevenue: number | null;
  } | null;
  readonly expenseItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly approved: boolean | null;
        readonly billable: boolean | null;
        readonly partOfFixedPrice: boolean | null;
        readonly expenseYear: number | null;
        readonly expenseMonth: number | null;
        readonly expenseDay: number | null;
        readonly price: number | null;
        readonly cost: number | null;
        readonly quantity: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly retainerPeriods: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly endYear: number | null;
        readonly endMonth: number | null;
        readonly endDay: number | null;
        readonly financialNumbers: {
          readonly billableActualMinutes: number | null;
          readonly retainerPeriodTargetPrice: number | null;
          readonly retainerPeriodRolloverPrice: number | null;
          readonly actualCost: number | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "HighLevelBudgetNumbers_project";
};
export type HighLevelBudgetNumbers_project$key = {
  readonly " $data"?: HighLevelBudgetNumbers_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"HighLevelBudgetNumbers_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentMonthLastDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentYear"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "expenseItems"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "retainerPeriods"
        ]
      }
    ]
  },
  "name": "HighLevelBudgetNumbers_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useBaseline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvoices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budget",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultPeriodBudgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeRegBasedPlusDoneScopeCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCard",
      "kind": "LinkedField",
      "name": "rateCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualRevenue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineProfit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualProfit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalRevenueProfitAtCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineMargin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actualMargin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalRevenueMarginAtCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billableActualTimeAndExpenses",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billableForecastTimeAndExpensesToComplete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecastCostToComplete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCostAtCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billableTotalTimeAndExpensesAtCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invoiced",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionProfit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionProfitPercentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalRevenueRecognition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectTotalForecastTimeAndExpensesToCompleteInPast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineVsForecastCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allActualTimeAndExpenses",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allForecastTimeAndExpensesToComplete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTotalTimeAndExpensesAtCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineTimeAndExpenses",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimatedCost",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "planVsTotalCostAtCompletion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billablePlannedTimeAndExpenses",
          "storageKey": null
        }
      ],
      "storageKey": "financialNumbers(convertToProjectCurrency:true)"
    },
    {
      "alias": "financialNumbersToCurrentMonth",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "endDay",
          "variableName": "currentMonthLastDay"
        },
        {
          "kind": "Variable",
          "name": "endMonth",
          "variableName": "currentMonth"
        },
        {
          "kind": "Variable",
          "name": "endYear",
          "variableName": "currentYear"
        }
      ],
      "concreteType": "FinancialNumbers",
      "kind": "LinkedField",
      "name": "financialNumbers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionLockedProfit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionLockedProfitPercentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recognitionLockedRevenue",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "expenseItems",
      "args": null,
      "concreteType": "ExpenseItemTypeConnection",
      "kind": "LinkedField",
      "name": "__Project_expenseItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExpenseItemTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "approved",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "billable",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "partOfFixedPrice",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseYear",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expenseDay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "price",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cost",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "quantity",
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "retainerPeriods",
      "args": null,
      "concreteType": "RetainerPeriodTypeConnection",
      "kind": "LinkedField",
      "name": "__HighLevelBudgetNumbers_retainerPeriods_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RetainerPeriodTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RetainerPeriodType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endYear",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endDay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v1/*: any*/),
                  "concreteType": "FinancialNumbers",
                  "kind": "LinkedField",
                  "name": "financialNumbers",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billableActualMinutes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "retainerPeriodTargetPrice",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "retainerPeriodRolloverPrice",
                      "storageKey": null
                    },
                    (v2/*: any*/)
                  ],
                  "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};
})();

(node as any).hash = "a221002ce47c01e093d7697206b906fd";

export default node;
